'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (type) {
  return !type.name.startsWith('__');
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/isNotGraphqlPrivateType.js
// module id = 479
// module chunks = 0